export const LEAVE_KIND_OPTIONS = ['MATERNITY_LEAVE', 'CHILDCARE_LEAVE', 'SICK_LEAVE', 'NURSING_CARE_LEAVE', 'OTHER'] as const;
export type LeaveKind = (typeof LEAVE_KIND_OPTIONS)[number];
export type LeaveKindFilterChipProps = {
  value: LeaveKind[] | undefined;
  onChange: (value: LeaveKind[] | undefined) => void;
};
export function isLeaveKind(value: string): value is LeaveKind {
  return (LEAVE_KIND_OPTIONS as readonly string[]).includes(value);
}